﻿import { useState } from "react";
import { styled } from "@mui/system";
import Radio from "@mui/material/Radio";

const ShepRadioButton = styled("span")(() => ({
  width: 18,
  height: 18,
  border: "1px solid var(--neutral-5)",
  borderRadius: "50%",
  margin: "-1px",

  "input:hover ~ &, input:focus-visible ~ &": {
    border: "1px solid var(--status-upcoming-intense)",
    margin: "-1px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='12' width='12' viewBox='0 0 12 12'%3E%3Ccircle cx='6' cy='6' r='5' fill='%23e4e6e5'/%3E%3C/svg%3E\")",
    content: '""',
  },
  "input:disabled ~ &": {
    border: "1px solid var(--grey-light)",
    margin: "-1px",
    backgroundColor: "var(--neutral-2)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='12' width='12' viewBox='0 0 12 12'%3E%3Ccircle cx='6' cy='6' r='5' fill='%23c4c7c6'/%3E%3C/svg%3E\")",
  },
  "input:active ~ &": {
    border: "3px solid #b7c1c6",
    margin: "-3px",
    borderRadius: "50%",
    backgroundImage: "none",
  },
}));

const ShepRadioMark = styled(ShepRadioButton)({
  border: "1px solid var(--primary-main)",
  margin: "-1px",
  backgroundColor: "var(--primary-main)",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",

  "&::before": {
    display: "block",
    width: 18,
    height: 18,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='12' width='12' viewBox='0 0 12 12'%3E%3Ccircle cx='6' cy='6' r='5' fill='white'/%3E%3C/svg%3E\")",
    content: '""',
  },
  "input:active ~ &": {
    border: "3px solid #b7c1c6",
    margin: "-3px",
    borderRadius: "50%",
  },
  "input:hover ~ &": {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
});

const ShepRadioButtonComponent = (props) => {
  return (
    <Radio
      sx={{
        minWidth: "3rem",
        "&:hover": { bgcolor: "transparent" },
        "&.MuiRadio-root": {
          pr: "1rem",
        },
      }}
      disableRipple
      color="default"
      checkedIcon={<ShepRadioMark />}
      icon={<ShepRadioButton />}
      inputProps={{ "aria-label": "Radio Button" }}
      {...props}
    />
  );
};

export default ShepRadioButtonComponent;
